'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchStaticHtml = exports.fetchResourceError = exports.fetchedResource = exports.fetchingResource = undefined;

var _http = require('../../utils/services/http');

var _http2 = _interopRequireDefault(_http);

var _staticResourceUtil = require('./staticResourceUtil');

var _staticResourceConstants = require('./staticResourceConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fetchingResource = exports.fetchingResource = function fetchingResource(_ref) {
    var resourceName = _ref.resourceName;
    return {
        type: _staticResourceConstants.RESOURCE_ACTION_TYPES.RESOURCE_FETCH,
        resourceName: resourceName
    };
};

// Constants
// Utils
var fetchedResource = exports.fetchedResource = function fetchedResource(_ref2) {
    var resourceName = _ref2.resourceName,
        data = _ref2.data;
    return {
        type: _staticResourceConstants.RESOURCE_ACTION_TYPES.RESOURCE_FETCH_SUCCESS,
        resourceName: resourceName,
        data: data
    };
};

var fetchResourceError = exports.fetchResourceError = function fetchResourceError(_ref3) {
    var resourceName = _ref3.resourceName,
        error = _ref3.error;
    return {
        type: _staticResourceConstants.RESOURCE_ACTION_TYPES.RESOURCE_FETCH_ERROR,
        resourceName: resourceName,
        error: error
    };
};

// TODO Migrate to the new resource fetching implementation
var fetchStaticHtml = exports.fetchStaticHtml = function fetchStaticHtml(htmlDocName) {
    return function (dispatch, getState) {
        var resourceName = (0, _staticResourceUtil.getStaticHtmlResourceName)(htmlDocName);

        var state = getState();
        var resource = state.get('app').get('staticResources').get(resourceName);

        if (resource && (resource.get('fetched') || resource.get('fetching'))) {
            return Promise.resolve();
        }

        dispatch(fetchingResource({ resourceName: resourceName }));

        return (0, _http2.default)({ prefix: 'html', url: htmlDocName + '.html', responseType: 'text', timeout: 10000 }).then(function (response) {
            dispatch(fetchedResource({ resourceName: resourceName, data: response.data }));
            return response;
        }).catch(function (err) {
            console.error('There was an error fetching the resource \'' + resourceName + '\'', err, err.response);
            dispatch(fetchResourceError({ resourceName: resourceName, error: err.response }));
            return Promise.reject(err.response);
        });
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/client/components/static/staticResourceActions.js
// module id = 1933
// module chunks = 0